import React from "react";

import "./theme.css";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { Box } from "@mui/material";

const PlayerApp = (props) => {
  const { playlist } = props;
  const [currentTrack, setTrackIndex] = React.useState(0);
  const handleClickNext = () => {
    let nextTrack = currentTrack < playlist.length - 1 ? currentTrack + 1 : 0;

    if (props.onClickNext) {
      props.onClickNext(nextTrack);
    }

    setTrackIndex(nextTrack);
  };

  const handleEnd = () => {
    if (props.onEnded) {
      props.onEnded();
    }

    setTrackIndex((currentTrack) =>
      currentTrack < playlist.length - 1 ? currentTrack + 1 : 0
    );
  };
  return (
    <Box>
      <Box mb={2}>
        <strong>Currently Playing:</strong> {currentTrack + 1} of{" "}
        {playlist.length}
        <br />
        <strong>Filename:</strong> {playlist[currentTrack].name}
        <br />
        <strong>Description:</strong>{" "}
        {playlist[currentTrack].description || "N/A"}
      </Box>
      <AudioPlayer
        volume="0.5"
        src={playlist[currentTrack].src}
        showSkipControls
        onClickNext={handleClickNext}
        onEnded={handleEnd}
      />
    </Box>
  );
};

export default PlayerApp;
